import { Util,Request } from "@xt/xtbase";
const { getOrigin } = Util;
const { XtAxios4 } = Request;

// const URL = getOrigin("www") + "/sapi/v4/market/public/";

// 查询阶梯费率表
export function getStepRates(config) {
  return XtAxios4.get(`/fapi/user/v1/public/user/step-rate/getStepRates`, config);
}

// 查询用户阶梯费率
export function getUserStepRate(config) {
  return XtAxios4.get(`/fapi/user/v1/user/step-rate/getUserStepRate`, config);
}

// 查询用户申请结果
export function getUserStepApplyResult(config) {
  return XtAxios4.get(`/fapi/user/v1/user/step-rate/getUserStepApplyResult`, config);
}

// 上传图片
export function postRateUpload(data, config) {
  return XtAxios4.post(`/fapi/user/v1/user/step-rate/upload`, data, config);
}

// 查询近期交易
export function getRecentTrade(config) {
  return XtAxios4.get(`/fapi/user/v1/user/step-rate/recent-trade`, config);
}

// 查询第三方平台
export function getOtherPlatforms(config) {
  return XtAxios4.get(`/fapi/user/v1/public/user/step-rate/getOtherPlatforms`, config);
}

// 申请阶梯费率
export function postUserStepApply(data, config) {
  return XtAxios4.post(`/fapi/user/v1/user/step-rate/userStepApply`, data, config);
}